// ELEMENTOR Trigger
(function($) {
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/cube-timeline-horizontal.default', function ($scope) {
      const elementSelector = `[data-id="${$scope.data('id')}"] .timeline-horizontal`;
      const swiperSettings = $(elementSelector).data('swiper'); // Get parameters from data-swiper attribute in HTML

      // Custom paging bullets
      swiperSettings.pagination.renderBullet = function (index, className) {
        // In loop mode, Swiper duplicates slides so the collection really starts from 1 instead of 0
        const title = this.slides[index + 1 ].dataset.title;
        return '<div class="' + className + '"><span class="bullet">' + (index + 1) +'</span><span class="timeline-horizontal-pagination-bullet-title">'+ title +'</span></div>';
      };

      const swiper = new Swiper(elementSelector, swiperSettings);
    });
  });
})(jQuery);
